import { BrowserModule } from '@angular/platform-browser';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WelcomeComponent } from './welcome/welcome.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FinancialdetailsComponent } from './financialdetails/financialdetails.component';
import { PropertydocumentsComponent } from './propertydocuments/propertydocuments.component';
import { PropertydetailsComponent } from './propertydetails/propertydetails.component';
import { OwnershipsummaryComponent } from './ownershipsummary/ownershipsummary.component';
import { OwnerdetailsComponent } from './ownerdetails/ownerdetails.component';
import { PropertyphotosComponent } from './propertyphotos/propertyphotos.component';
import { OtppromptComponent } from './otpprompt/otpprompt.component';
import { OwnersdocumentsComponent } from './ownersdocuments/ownersdocuments.component';
import {MatTabsModule, MAT_TABS_CONFIG} from '@angular/material/tabs';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { PropertyphotodetailsComponent } from './propertyphotodetails/propertyphotodetails.component';
import { DocumentviewerComponent } from './documentviewer/documentviewer.component';
import { MaintenancenoticeComponent } from './maintenancenotice/maintenancenotice.component';
import { PinchangeComponent } from './pinchange/pinchange.component';
import { DocumentUpdateComponent } from './document-update/document-update.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoadingProgressComponent } from './loading-progress/loading-progress.component';
import { CustomercareComponent } from './customercare/customercare.component';
import { MapviewComponent } from './mapview/mapview.component';
import { BlockcardComponent } from './blockcard/blockcard.component';
import { PropertydocumentscatComponent } from './propertydocumentscat/propertydocumentscat.component';
import { EmailProgressComponent } from './email-progress/email-progress.component';
import { SummarymailprogressComponent } from './summarymailprogress/summarymailprogress.component';
import { Summarysheet1Component } from './summarysheet1/summarysheet1.component';
import { WhatsappProgressComponent } from './whatsapp-progress/whatsapp-progress.component';
import { PropertydocumentdetailsComponent } from './propertydocumentdetails/propertydocumentdetails.component';

import { SummaryMessageProgressComponent } from './summary-message-progress/summary-message-progress.component';
import { DatePipe } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AadhaarLoginComponent } from './aadhaar-login/aadhaar-login.component';
import { AadhaarOtpComponent } from './aadhaar-otp/aadhaar-otp.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    LoginComponent,
    DashboardComponent,
    FinancialdetailsComponent,
    PropertydocumentsComponent,
    PropertydetailsComponent,
    OwnershipsummaryComponent,
    OwnerdetailsComponent,
    PropertyphotosComponent,
    OtppromptComponent,
    OwnersdocumentsComponent,
    PropertyphotodetailsComponent,
    DocumentviewerComponent,
    MaintenancenoticeComponent,
    PinchangeComponent,
    DocumentUpdateComponent,
    LoadingProgressComponent,
    CustomercareComponent,
    MapviewComponent,
    BlockcardComponent,
    PropertydocumentscatComponent,
    EmailProgressComponent,
    SummarymailprogressComponent,
    Summarysheet1Component,
    WhatsappProgressComponent,
    SummaryMessageProgressComponent,
    PropertydocumentdetailsComponent,
    AadhaarLoginComponent,
    AadhaarOtpComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    NoopAnimationsModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    PdfViewerModule,
    GoogleMapsModule,
  ],
  providers: [
    DatePipe,
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

